import _findNumbers from './findNumbers_';
import { sort_out_arguments } from './parsePhoneNumber';

export default function findNumbers(arg_1, arg_2, arg_3, arg_4) {
	var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
	    text = _sort_out_arguments.text,
	    options = _sort_out_arguments.options,
	    metadata = _sort_out_arguments.metadata;

	return _findNumbers(text, options, metadata);
}
//# sourceMappingURL=findNumbers.js.map